(function(){
  const chart=[{size:'S',width:19,length:26.75},{size:'M',width:21,length:27.75},{size:'L',width:23,length:28.75},{size:'XL',width:25,length:29.75},{size:'2XL',width:27,length:30.75},{size:'3XL',width:29,length:31.75}];
  function init(scope){
    scope.querySelectorAll('[data-1801-guide]').forEach((guide)=>{
      if(guide.dataset.ready)return;
      guide.dataset.ready='true';
      const text=(key)=>guide.getAttribute('data-text-'+key);
      const tabs=[...guide.querySelectorAll('[data-1801-tab]')];
      const activate=(target)=>{
        tabs.forEach((tab)=>{const on=tab.dataset['1801Tab']===target;tab.setAttribute('aria-selected',String(on));tab.tabIndex=on?0:-1;});
        guide.querySelectorAll('[data-1801-panel]').forEach((panel)=>{panel.hidden=panel.getAttribute('data-1801-panel')!==target;});
      };
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>activate(tab.getAttribute('data-1801-tab')));
        tab.addEventListener('keydown',(event)=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(event.key)){event.preventDefault();const next=(event.key==='Home'||event.key==='End')?(event.key==='Home'?0:1):1-index;activate(tabs[next].getAttribute('data-1801-tab'));tabs[next].focus();}});
      });
      guide.querySelectorAll('[data-1801-unit]').forEach((button)=>button.addEventListener('click',()=>{
        const unit=button.getAttribute('data-1801-unit');
        guide.querySelectorAll('[data-1801-unit]').forEach((item)=>item.setAttribute('aria-pressed',String(item===button)));
        guide.querySelectorAll('td[data-inch]').forEach((cell)=>{cell.textContent=Number(cell.getAttribute('data-'+unit)).toString();});
      }));
      const height=guide.querySelector('[data-1801-height]');
      const weight=guide.querySelector('[data-1801-weight]');
      const result=guide.querySelector('[data-1801-result]');
      [height,weight].forEach((input)=>['input','change'].forEach((event)=>input.addEventListener(event,()=>{result.hidden=true;})));
      guide.querySelector('[data-1801-match]').addEventListener('click',()=>{
        const h=Number(height.value),w=Number(weight.value);
        result.replaceChildren();result.hidden=false;
        const add=(tag,value)=>{const item=document.createElement(tag);item.textContent=value;result.appendChild(item);};
        if(!height.value||!weight.value||!Number.isFinite(h)||!Number.isFinite(w)||h<=0||w<=0){add('p',text('invalid'));return;}
        const adjustedWeight=w*69/h;
        if(h<58||h>78||w<80||w>400||adjustedWeight<85||adjustedWeight>305){add('p',text('outside'));return;}
        const cutoffs=[130,165,200,235,270];
        const index=cutoffs.findIndex((cutoff)=>adjustedWeight<cutoff);
        const match=chart[index===-1?5:index];
        add('strong',text('match')+' '+match.size);
        add('p',text('chart-dimensions')+' '+text('width')+' '+match.width+' '+text('unit-in')+' · '+text('length')+' '+match.length+' '+text('unit-in')+'.');
        if(index!==-1)add('p',text('fit-note'));
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',(event)=>init(event.target));
})();
